import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route, useLocation } from 'react-router-dom';
import { UsersListPage } from './UsersListPage';
import { UsersEditPageWrapper } from './UsersEditPageWrapper';

export function UsersPage({ isExpanded }) {
  const location = useLocation();
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<UsersListPage isExpanded={isExpanded} />}
      />
      <Route
        path="add"
        element={<UsersEditPageWrapper isExpanded={isExpanded} />}
      />
      <Route
        path="edit/:id"
        element={<UsersEditPageWrapper isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

UsersPage.propTypes = {
  isExpanded: propTypes.bool.isRequired,
};
